<template>
  <div class="parent-table">
    <base-dialog
      :visible="dialogVisible"
      width="calc(100% - 400px)"
      class="dialog-wrap"
      border-radius="none"
      @open="open"
      @closed="close"
      show-close
    >
      <template v-slot:header>
        <div class="header-wrap">
          <div class="title">{{ taskGroup.name }}</div>
        </div>
      </template>
      <div class="top-wrap">
        <search-box :project-id="projectId" @search="setSearchInfo" class="search-box"></search-box>
      </div>
      <task-table
        ref="taskTable"
        from="parent"
        :task-group="taskGroup"
        :project-id="projectId"
        :child-id="taskIds"
        :search-info="searchInfo"
        :show-selection="false"
        :height="3 - taskLevel"
        @row-click="rowClick"
      ></task-table>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import TaskTable from "@/views/Front/Project/TaskList/TaskTable"
import SearchBox from "@/views/Front/Project/TaskList/SearchBox"

export default {
  name: "parent-table",
  components: {
    SearchBox,
    TaskTable,
    BaseDialog
  },
  props: {
    dialogVisible: Boolean,
    projectId: String,
    taskGroup: Object,
    taskLevel: Number,
    taskIds: Array
  },
  data() {
    return {
      select: "",
      searchInfo: {
        searchKey: null,
        searchValue: null
      }
    }
  },
  methods: {
    open() {
      this.$nextTick(() => {
        this.$refs.taskTable?.init()
      })
    },
    close() {
      this.$emit("update:dialogVisible", false)
    },
    setSearchInfo(searchKey, searchValue) {
      this.searchInfo = {
        searchKey,
        searchValue
      }
    },
    rowClick(data) {
      this.$emit("select", data)
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  ::v-deep .el-dialog {
    min-width: 1080px;
    height: 86%;
    color: $color-font-first;
    .title {
      font-size: $font-size-title-second;
      font-weight: bold;
    }
    .el-dialog__headerbtn {
      top: 12px;
    }
    .el-dialog__body {
      position: relative;
      padding: 0 !important;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      .top-wrap {
        display: flex;
        align-items: center;
        height: 57px;
        margin: 0 20px;
        .search-box {
          margin-left: auto;
          margin-right: 6px;
        }
      }
      .task-table {
        flex: auto;
        margin-bottom: 8px;
        overflow: hidden;
      }
      .pagination-wrap {
        margin-top: 6px;
      }
    }
  }
}
</style>
